var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6499 9.10771L5.37717 1.60771C5.00049 1.21925 4.48247 1 3.94137 1H2.7253C0.958283 1 0.0593965 3.12375 1.2895 4.39229L5.86202 9.10771C6.61429 9.88348 6.61429 11.1165 5.86202 11.8923L1.2895 16.6077C0.0593963 17.8762 0.958285 20 2.7253 20H3.94137C4.48247 20 5.00049 19.7808 5.37717 19.3923L12.6499 11.8923C13.4022 11.1165 13.4022 9.88348 12.6499 9.10771Z",
    stroke: "#3B8BEC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow.8fe7e4fe31151db2eb913a0f10d3d063.svg";